import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { LoginModel } from "../models/login.model";
import { Observable, throwError } from "rxjs";
import { map, catchError} from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { postAuthorizeServerResModel } from "../models/serverResponse.model";
import { postAuthorizeServiceResModel } from "../models/serviceResponse.model";
import { CookieManagementService } from "./cookie-management.service";
import { AppConfig } from "src/app/config-service/app.config";
import { VersionHelper } from "src/app/utility-packages/versionHelper/version-helper";

@Injectable()

export class AuthorizeService{
  constructor(
    private http: HttpClient, 
    private translate: TranslateService, 
    private cookieManagementService: CookieManagementService,
    private versionHelper: VersionHelper
  ){}

  headers = new HttpHeaders({
    "Content-Type": "application/json"
  });

  public postAuthorize(obLogin: LoginModel):Observable<any>{
    let url = AppConfig.settings.apiServer.authUrl + 'oauth/authorize?region=' + AppConfig.settings.city.region + '&authType=' + AppConfig.settings.apiServer.authType + '&version=' + this.versionHelper.getVersion() + '&lang=' + this.cookieManagementService.getlanguage();
    let body = {
      clientId: AppConfig.settings.apiServer.clientId,
      loginType: obLogin.loginType,
      responseType: "code"
    };

    if(obLogin.loginType == 'phone'){
      body['countryCode' as keyof typeof body] = obLogin.countryCode;
      body['phoneNumber' as keyof typeof body] = obLogin.phoneNumber;
    }
    else if(obLogin.loginType == 'email'){
      body['email' as keyof typeof body] = obLogin.email;
      body['countryCode' as keyof typeof body] = 'tr';
    }
    else{
      return throwError(this.translate.instant('DEFAULT_ERROR_MESSAGE'));
    }

    if(obLogin.pin != ''){
      body['pin' as keyof typeof body] = obLogin.pin;
    }
    else if(obLogin.otpCode != '' && obLogin.refNo != ''){
      body['refNo' as keyof typeof body] = obLogin.refNo;
      body['otpCode' as keyof typeof body] = obLogin.otpCode;
    }
    else{
      return throwError(this.translate.instant('DEFAULT_ERROR_MESSAGE'));
    }
    
    return this.http.post<postAuthorizeServerResModel>(url, body, {
      headers: this.headers,
      responseType: 'json'
    }).pipe(
      map((response: postAuthorizeServerResModel) => {
          try{
            if(response && response.result){
              if(response.result.hasOwnProperty('code') && response.result.code === 0 && response.code){
                return new postAuthorizeServiceResModel(false, response.code, '');
              }
              else if(response.result.hasOwnProperty('code') && response.result.code !== 0 && response.result.message){
                return new postAuthorizeServiceResModel(true, '', response.result.message);
              }
              else{
                return new postAuthorizeServiceResModel(true, '', this.translate.instant('DEFAULT_ERROR_MESSAGE'));
              }
            }
            else{
              return new postAuthorizeServiceResModel(true, '', this.translate.instant('DEFAULT_ERROR_MESSAGE'));
            }
          }
          catch(err){
            return new postAuthorizeServiceResModel(true, '', this.translate.instant('DEFAULT_ERROR_MESSAGE'));
          }
        }),
        catchError( error => {
          if(typeof error === 'string'){
              return throwError(error);
          }
          else{
            return throwError(this.translate.instant('DEFAULT_ERROR_MESSAGE'));
          }
        })
      )
  }
}